/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskTicketTypesConfig from '@jira/spa-apps__project-settings-service-desk-ticket-types-config/src/ServiceDeskTicketTypesConfigPage.tsx';
import { HelpCenterSettingsRedirect } from '@jira/servicedesk__customer-service-common/src/HelpCenterSettingsRedirect.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskTicketTypesConfig: LazyComponent<
	() => React.JSX.Element
> = lazyForPaint<typeof ProjectSettingsServiceDeskTicketTypesConfig>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-ticket-types-config", jiraSpaEntry: "async-project-settings-service-desk-ticket-types-config" */ '@jira/spa-apps__project-settings-service-desk-ticket-types-config/src/ProjectSettingsServiceDeskTicketTypesConfig.tsx'
		),
);

const AsyncProjectSettingsServiceDeskTicketTypesConfig = (): React.JSX.Element => (
	<HelpCenterSettingsRedirect page="ticket-types-config">
		<LazyPage
			Page={LazyProjectSettingsServiceDeskTicketTypesConfig}
			pageId="project-settings-ticket-types-config"
			shouldShowSpinner
		/>
	</HelpCenterSettingsRedirect>
);

export default AsyncProjectSettingsServiceDeskTicketTypesConfig;
